import {
  Component,
  ElementRef,
  OnInit,
  signal,
  viewChild,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ESearchType, ISearchResponse } from '../../search-extras/search.interface';
import { SearchService } from '../../search-extras/search.service';
import PS from 'perfect-scrollbar';
import { MenuItem } from '@Shared/models/IMenuItem';
import { configForms } from '@Shared/models/form.class';
import { environment } from 'projects/evolutics-shared-lib/src/environments/environment';
import { SystemLinkPipe } from '../../search-extras/search.pipe';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { RouterLink } from '@angular/router';
import { SearchCaseDirective } from '../../search-extras/search.directive';
import { NgClass, AsyncPipe, I18nPluralPipe } from '@angular/common';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { PSDirective } from '../../../../directives/index.directive';

@Component({
  selector: 'app-navbar-search',
  templateUrl: './navbar-search.component.html',
  styleUrls: ['./navbar-search.component.scss'],
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    SearchCaseDirective,
    RouterLink,
    AsyncPipe,
    I18nPluralPipe,
    TranslatePipe,
    SystemLinkPipe,
    MatMenuModule,
    PSDirective
],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarSearchComponent implements OnInit {
  // showSearch = environment.production ? false : true;
  readonly showSearch = signal(false);
  searching = false;
  query = configForms.default();
  mainResults: MenuItem[];
  helpResults: MenuItem[];
  resultLength: number;
  results: ISearchResponse[];
  resultLengthMap = {
    '=1': 'result',
    other: 'results',
  };
  readonly matMenuTrigger = viewChild(MatMenuTrigger);
  helpLink = environment.helpLink;
  constructor(public sS: SearchService) {}

  ngOnInit(): void {
    this.query.valueChanges
      .pipe(
        map(async (r) => {
          this.searching = true;
          return this.sS.search(r);
        }),
      )
      .subscribe(async (res) => {
        this.searching = false;
        const r = await res;
        this.results = r?.filter((x) => x.menuItems?.length);
        // console.log(r);
        this.resultLength = r?.reduce((total, x) => total + (x.menuItems?.length || 0), 0);

        // console.log(this.ps);
      });
  }
  ngAfterViewInit(): void {}
  ngOnDestroy(): void {}
  get queryValue() {
    return this.query.value?.trim();
  }
  openLink() {
    // this.showSearch = false;
    this.matMenuTrigger()?.closeMenu();
  }
  toggleSearch() {}
  closeSearch() {
    this.matMenuTrigger()?.closeMenu();
  }
}
